<template>
  <div v-click-outside="close" class="relative">
    <div id="time_picker" @click="isOpen = !isOpen">
      <p v-if="!daypart" class="text-cebeo_gray">{{ $t('components.chooseADaypart') }}*</p>
      <p v-if="daypart">
        {{ $t(`dayparts.${daypart}`) }}
      </p>
      <img src="../../assets/icons/angle-down.svg"/>
    </div>
    <div v-if="isOpen" id="dropdown_content">
      <div v-for="daypart in dayparts" @click="setDaypart(daypart)">
        <p class="option_item" :class="{'selected': daypart && daypart.id === daypart.id}">
          {{ $t(`dayparts.${daypart}`) }}</p>
      </div>
      <div v-if="dayparts.length === 0">
        <p class="option_item no_slots">
          {{ $t('components.noDaypartsAvailable') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3';
import formatTime from '@/mixins/formatTime';

export default {
  name: 'DaypartPicker',

  mixins: [formatTime],

  props: {
    date: { required: true },
    daypart: { required: true },
    store: { required: true }
  },

  data() {
    return {
      isOpen: false,
      dayparts: []
    };
  },

  watch: {
    'date'() {
      this.fetchDayparts();
      this.$emit('clear-time');
    }
  },

  methods: {
    setDaypart(slot) {
      this.$emit('update:daypart', slot);
      this.isOpen = false;
    },

    async fetchDayparts() {
      const data = {
        date: this.date,
        storeId: this.store.id
      };

      this.dayparts = await this.$store.dispatch('getDayparts', data);
    },

    close() {
      this.isOpen = false;
    }
  },

  directives: {
    clickOutside: vClickOutside.directive
  },
};
</script>
<style scoped>
#time_picker {
  height: 50px;
  line-height: 50px;
  @apply bg-cebeo_blue_faded text-left px-10 uppercase flex justify-between items-center shadow-md cursor-pointer;
}

#dropdown_content {
  @apply absolute w-full bg-white text-left pt-1 border border-t-0 cursor-pointer;
}

.option_item {
  height: 35px;
  line-height: 35px;
  @apply px-10;
}

.selected {
  @apply bg-cebeo_blue_faded
}
</style>
